import React from 'react';
import PropTypes from 'prop-types';
import { SettingsIcon } from '../../model/icons';

// Шапка игры (.head-card): заголовок, мета-строка, кнопка настроек, строка статуса.
// Презентационный — данные передаёт конкретная игра.
export default function GameHeader({ title, meta, onSettings, status }) {
    return (
        <section className="head-card">
            <div className="fr-hcard">
                <h1 className="gh-title">{title}</h1>
                {meta && <div className="meta-line gh-meta">{meta}</div>}
                {onSettings && (
                    <button type="button" className="btn btn-primary gh-gear" onClick={onSettings}>
                        <span className="ic"><SettingsIcon /></span>
                        Настройки игры
                    </button>
                )}
                {status && <div className="fr-statrow gh-stat">{status}</div>}
            </div>
        </section>
    );
}

GameHeader.propTypes = {
    title: PropTypes.string.isRequired,
    meta: PropTypes.node,
    onSettings: PropTypes.func,
    status: PropTypes.node
};

GameHeader.defaultProps = { meta: null, onSettings: null, status: null };
